/**
 * Checks if the given install type is 'premise'.
 *
 * @param installType - the installation type to check.
 * @returns true if the install type is 'cloud'; otherwise, false.
 */
export function isCloudInstall(installType: string): boolean {
  return installType === "cloud";
}
